/* eslint-disable prettier/prettier */
import {
  snakeToCamel,
  snakeToCamelTemplateLiterals,
} from '@/common/converter/utils/snake-to-camel'
import { replacePlaceholder } from '@/common/converter/utils/replace-placeholder'
import { convertTitleList } from '@/common/converter/convert-title-list'
import { convertCellEvent } from '@/common/converter/convert-cell-event'

/**
 * source object (home) 와 target object (catalog) 를 받아
 * target object 에 source object 를 참조하여 cell property 생성
 * 구 cell 형태를 반환
 * @param source
 * @param target
 * @returns {{age_tag: string, thumbnail: string, alt: string, update_taglist: (string[]|*[]), event_list: {bodylist: *, url: string}[], title_list: unknown[], progress: (*|string), rank: (string|string), time: (*|string), force_refresh: string, brand_taglist: string[], bottom_taglist: string[], top_taglist: (string[]|*[]), age: (string|number|*)}}
 */
export const convertCell = (source = {}, target = {}) => {
  const { contextProperty = {}, eventList = [] } = source

  const thumbnail = snakeToCamel(contextProperty?.image?.thumbnail) ?? ''
  const alt = snakeToCamel(contextProperty?.alt) ?? ''
  const titleList = contextProperty?.titleList.map(snakeToCamelTemplateLiterals) ?? []
  const brandTagList = contextProperty?.tag?.brandList ?? []
  const topTagList = contextProperty?.tag?.topList ?? []
  const updateTagList = contextProperty?.tag?.updateList ?? []
  const bottomTagList = contextProperty?.tag?.bottomList ?? []
  const rank = snakeToCamel(contextProperty?.rank?.order) ?? ''

  return {
    thumbnail: replacePlaceholder(thumbnail, target),
    alt: replacePlaceholder(alt, target),
    force_refresh: '',
    top_taglist: topTagList.map((tag) => replacePlaceholder(tag, target)) ?? [],
    brand_taglist: brandTagList.map((tag) => replacePlaceholder(tag, target)),
    age: target?.personal?.targetage ?? '',
    age_tag: '',
    bottom_taglist: bottomTagList.map((tag) => replacePlaceholder(tag, target)),
    update_taglist: updateTagList.map((tag) => replacePlaceholder(tag, target)) ?? [],
    time: target?.personal?.remainMinute ?? '',
    progress: target?.personal?.viewratio ?? '',
    rank: replacePlaceholder(rank, target) ?? '',
    title_list: titleList.map((title) => convertTitleList(replacePlaceholder(title, target)) ?? [],),
    event_list: eventList.map((event) => convertCellEvent(event, target)),
  }
}
